import React from 'react';

import { Row } from 'antd';
import { Formik, Form as FormikForm, FormikHelpers } from 'formik';
import Logo from 'assets/logo/logo_full.png';
import InputField from 'shared/components/InputField';
import COButton from 'shared/components/COButton';
import styles from './VerifyEmailForgotPass.module.scss';
import AuthenticationService from 'services/AuthenticationService/authentication.service';
import { VerifyEmailForgotPassProps } from 'enums/VerifyEmailForgotPassEnums';
import {
  initialValues,
  validationSchema,
  Fields,
} from './VerifyEmailForgotPassConstants';
import { useNavigate } from 'react-router-dom';
interface VerifyEmailProps {
  email: string | undefined;
  forgotPass?: boolean;
}

interface VerifyEmailForgotPassFormValues {
  otp: string;
}

const VerifyEmailForgotPassForm: React.FC<VerifyEmailProps> = ({
  email,
}: VerifyEmailProps) => {
  const navigate = useNavigate();

  const { buttonLoading, verifyOTPForgotPass, forgotPassword } =
    AuthenticationService();
  const handleApiSubmission = (values: VerifyEmailForgotPassFormValues) => {
    verifyOTPForgotPass(email as string, {
      email: email,
      otp: Number(values.otp),
    });
  };
  const handleGoBack = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    e.preventDefault();
    navigate(-1);
  };

  const handleResendOtp = (
    e: React.MouseEvent<HTMLElement>,
    setFieldValue: FormikHelpers<VerifyEmailForgotPassFormValues>['setFieldValue']
  ) => {
    e.stopPropagation();
    setFieldValue('otp', '');
    email && forgotPassword({ email });
  };

  return (
    <div className={styles.formContainer}>
      <Row className={styles.logoContainer}>
        <img
          src={Logo}
          alt={VerifyEmailForgotPassProps.IMAGE_ALT}
          className={styles.logo}
        />
      </Row>
      <Row className={styles.headingContainer}>
        <div>
          <h1>{VerifyEmailForgotPassProps.HEADING}</h1>
        </div>
        <div>
          <h2>{VerifyEmailForgotPassProps.SUBHEADING}</h2>
        </div>
      </Row>
      <div className={styles.fieldsContainer}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={values => handleApiSubmission(values)}>
          {formik => (
            <FormikForm>
              {Fields.map((field, index) => {
                return (
                  <div key={index} className={styles.fieldContainer}>
                    <InputField
                      name={field.name}
                      placeholderstring={field.placeholder}
                      label={field.label}
                      maxLength={field.maxLength}
                    />
                    {field.helper && (
                      <div className={styles.helpercontainer}>
                        <p>
                          {VerifyEmailForgotPassProps.HELPER_TEXT}{' '}
                          <span
                            className={styles.spanText}
                            onClick={e =>
                              handleResendOtp(e, formik.setFieldValue)
                            }>
                            {VerifyEmailForgotPassProps.HELPER_TEXT_SPAN}
                          </span>
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}

              <div className={styles.buttonContainer}>
                <COButton
                  submit
                  loading={buttonLoading}
                  disabled={!formik.isValid}>
                  {VerifyEmailForgotPassProps.BUTTON_LABEL_SUBMIT}
                </COButton>
                <COButton secondary onClick={handleGoBack}>
                  {VerifyEmailForgotPassProps.BUTTON_LABEL_BACK}
                </COButton>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default VerifyEmailForgotPassForm;
